import { SimpleCenterLayout } from "@mnk/frontend/components/layouts/SimpleCenterLayout";
import { PrimaryButton } from "@mnk/frontend/components/ui/button/PrimaryButton";
import { Success } from "@mnk/frontend/components/ui/flashMessage/Success";
import { useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { trpc } from "../../lib/trpc";

export const PasswordReset = () => {
  const [password, setPassword] = useState("");
  const [passwordConfirmation, setPasswordConfirmation] = useState("");
  const [processing, setProcessing] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const [success, setSuccess] = useState(false);
  const navigate = useNavigate();

  const resetPasswordMutation = trpc.resetPassword.useMutation();
  const [searchParams] = useSearchParams();
  const token = searchParams.get("token");

  return (
    <SimpleCenterLayout>
      <h2 className="text-xl font-bold text-center">パスワードリセット</h2>

      {success ? (
        <div className="mt-4">
          <Success message="パスワードを再設定しました" />
          <PrimaryButton onClick={() => navigate("/login")} className="mt-4 w-full">
            ログイン画面へ
          </PrimaryButton>
        </div>
      ) : (
        <>
          <div className="flex flex-col gap-2 my-4 px-2">
            <label htmlFor="password" className="text-sm text-gray-500">
              新しいパスワード
            </label>
            <input
              id="password"
              type="password"
              className="border border-gray-300 rounded-md p-2"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
            />
          </div>

          <div className="flex flex-col gap-2 my-4 px-2">
            <label htmlFor="passwordConfirmation" className="text-sm text-gray-500">
              新しいパスワード（確認）
            </label>
            <input
              id="passwordConfirmation"
              type="password"
              className="border border-gray-300 rounded-md p-2"
              value={passwordConfirmation}
              onChange={(e) => setPasswordConfirmation(e.target.value)}
            />
          </div>

          {error && <p className="text-sm text-red-500 text-center">{error}</p>}

          <PrimaryButton
            onClick={async (e) => {
              e.preventDefault();
              if (password !== passwordConfirmation) {
                setError("パスワードが一致しません");
                return;
              }

              try {
                setProcessing(true);
                await resetPasswordMutation.mutateAsync({ token: token || "", password });
                setSuccess(true);
              } catch (error) {
                setError("パスワードのリセットに失敗しました");
              } finally {
                setProcessing(false);
              }
            }}
            className="mt-8 w-full"
            disabled={processing || !token || !password || !passwordConfirmation}
          >
            パスワードを再設定する
          </PrimaryButton>
        </>
      )}
    </SimpleCenterLayout>
  );
};
